/* INOXMETALL – Titel nie mitten im Wort trennen: Schrift verkleinern, bis das laengste Wort passt */
(function(){
var SEL='main h1,main h2,main h3,.ix h1,.ix h2,.ix h3,.ix-buy__big,.ix-h2,.ix-feature__h,.ix-card__title,.ix-tile__title,.ix-hero__h';
/* Woerter mit Bindestrich zusammenhalten (z. B. Feinsteinzeug-Einsatz) */
function glue(el){
  if(el.getAttribute('data-ix-glued'))return;el.setAttribute('data-ix-glued','1');
  var tw=document.createTreeWalker(el,4),nodes=[],n;while((n=tw.nextNode()))nodes.push(n);
  nodes.forEach(function(t){
    if(!/[^\s]-[^\s]/.test(t.data)||(t.parentNode&&t.parentNode.closest&&t.parentNode.closest('script,style')))return;
    var frag=document.createDocumentFragment();
    t.data.split(/(\s+)/).forEach(function(p){
      if(/[^\s]-[^\s]/.test(p)){var s=document.createElement('span');s.style.whiteSpace='nowrap';s.textContent=p;frag.appendChild(s);}
      else if(p){frag.appendChild(document.createTextNode(p));}
    });
    t.parentNode.replaceChild(frag,t);
  });
}
function fit(el){
  if(el.querySelector(SEL))return;
  el.style.fontSize='';
  var w=el.clientWidth;if(!w)return;
  if(el.scrollWidth<=w+1)return;
  var fs=parseFloat(getComputedStyle(el).fontSize),min=fs*0.4,i=0;
  while(el.scrollWidth>w+1&&fs>min&&i<40){fs=fs*0.95;el.style.fontSize=fs.toFixed(1)+'px';i++;}
}
function run(){var els=document.querySelectorAll(SEL);for(var i=0;i<els.length;i++){glue(els[i]);fit(els[i]);}}
var t;function later(){clearTimeout(t);t=setTimeout(run,120);}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',run);}else{run();}
window.addEventListener('load',run);
window.addEventListener('resize',later);
if(document.fonts&&document.fonts.ready){document.fonts.ready.then(run);}
document.addEventListener('shopify:section:load',later);
})();
